<template>
  <div :id="'ks_modal_new' + _uid" class="z-index-ten-thousand" v-if="opened">
    <div v-if="!backdropClose" class="backdrop"></div>
    <div :class="[classes]">
      <div id="modalcontent" class="card ks-modal-new"
           :style="`height: ${height}; width: ${width};`"
      >
        <div class="modalheader" v-if="showHeader">
          <div class="modal-title d-flex align-items-end" v-if="title || subtitle"
               :class="{'flex-row': titleLayout === 'horizontal', 'flex-column': titleLayout === 'vertical',}">
            <h5 class="modal-title" v-if="title">
              {{ title }}
            </h5>
            <div class="modal-title" v-if="subtitle" :class="{'pl-1':title}" style="padding-bottom: 2px;">
              {{ subtitle }}
            </div>
          </div>
          <button type="button" class="close" @click.prevent="close" aria-label="Close" v-if="enableClose">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <template v-if="opened || preRender">
          <ks-spinner ref="modal_spinner"/>
          <slot></slot>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import state from '../../mixins/state';

export default {
  name:     'ks-ui-modal',
  mixins:   [state],
  props:    {
    showHeader:             {type: Boolean, default: true}
    , showFooter:           {type: Boolean, default: true}
    , title:                {type: String, default: null}
    , subtitle:             {type: String, default: null}
    , titleLayout:          {type: String, default: 'vertical'}
    , emitOnly:             {type: Boolean, default: false}
    , enableClose:          {type: Boolean, default: true}
    , backdropClose:        {type: Boolean, default: true}
    , position:             {type: String, default: null}
    , size:                 {type: String, default: null} //sm-md-lg
    , closeType:            {type: String, default: 'close'}
    , modalWidth:           {type: String, default: null} // "25","50","75"or"100"
    , dataBackdrop:         {type: Boolean, default: true}
    , dataKeyboard:         {type: Boolean, default: true}
    , disabled:             {type: Boolean, default: false}
    , bodyClass:            {type: String, default: ''}
    , beforeClose:          {type: Function, default: null}
    , confirmRecordChanges: {type: String, default: null}
    , preRender:            {type: Boolean, default: false}
    , width:                {type: String, default: '80vw'}
    , height:               {type: String, default: '80vh'}
  },
  computed: {
    loading: {
      get: () => {
        return app.store.state.ks_app.global_data.loading;
      },
      set: (value) => {
        app.store.commit('ks_app/global_data/setLoading', value);
      }
    },
    classes() {
      let size     = this.size ? `modal-${this.size}` : '';
      let centered = this.position == 'centered' ? 'modal-dialog-centered' : '';
      let width    = this.modalWidth ? `w-${this.modalWidth} mw-100` : '';
      return `${size} ${centered} ${width}`;
    },
    hasSlotBody() {
      return !!this.$slots.body;
    },
    hasSlotFooter() {
      return !!this.$slots.footer;
    },
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    }
  },
  watch:    {
    opened:  function (val) {
      if (val) {
        $(".ks-left-drawer").css("z-index", -2);
        $(".ks-left-drawer-menu").css("z-index", -2);
        $(".ks-right-drawer").css("z-index", -2);
        $(".ks-right-drawer-menu").css("z-index", -2);
        $(".left-nav-button").css("z-index", -1);
        $(".right-nav-button").css("z-index", -1);
        $(".fixed-top").css("z-index", -1);
        $(".menu-layer").css("z-index", -1);
      } else {
        $(".ks-left-drawer").css("z-index", 110);
        $(".ks-left-drawer-menu").css("z-index", 160);
        $(".ks-right-drawer").css("z-index", 110);
        $(".ks-right-drawer-menu").css("z-index", 160);
        $(".left-nav-button").css("z-index", 3);
        $(".right-nav-button").css("z-index", 3);
        $(".fixed-top").css("z-index", 1030);
        $(".menu-layer").css("z-index", 1041);
      }
    },
    loading: function (val) {
      if (val) {
        if (this.$refs.modal_spinner) this.$refs.modal_spinner.show();
      } else {
        if (this.$refs.modal_spinner) this.$refs.modal_spinner.hide();
      }
    }
  },
  methods:  {
    async close() {
      let close = true;
      if (this.beforeClose !== null) {
        try {
          close = await this.beforeClose();
        } catch (err) {
          close = false;
          console.log(err);
        }
      } else if (this.confirmRecordChanges !== null && typeof app.dataproviders[this.confirmRecordChanges] !== 'undefined') {
        try {
          close = await app.dataproviders[this.confirmRecordChanges].confirmDisregardChanges();
        } catch (err) {
          close = false;
          console.log(err);
        }
      }
      if (close) {
        if (this._state && this.enableClearState) this._state.ref.clearState(this._state.name, this._state.data);
        if (!this.emitOnly) this.hide();
        this.$emit(this.closeType, this);
      }
    },
    show() {
      this.opened = true;
      if (this._state && this.enableClearState) this._state.ref.clearState(this._state.name, this._state.data);
      /*if (!this.backdropClose) {
        $("#ks_modal_" + this._uid).modal({backdrop: 'static', keyboard: false});
      }*/
      // $('#ks_modal_' + this._uid).modal('show');
      this.$emit('open', this);
    },
    hide() {
      this.opened = false;
      // $('#ks_modal_' + this._uid).modal('hide');
    },
    setEmit() {
      let _this = this;
      //todo create emit events
      /*$('#ks_modal_' + _this._uid).on("hide.bs.modal", () => {
        _this.$emit("closing");
      });
      $('#ks_modal_' + _this._uid).on("hidden.bs.modal", () => {
        _this.opened = false;
        _this.$emit("closed");
      });
      $('#ks_modal_' + _this._uid).on('show.bs.modal', () => {
        _this.opened = true;
        _this.$emit("opening");
      });
      $('#ks_modal_' + _this._uid).on('shown.bs.modal', () => {
        _this.$emit("opened");
      });*/
    }
  },
  mounted() {
    this.setEmit();
  },
  data() {
    return {
      opened: false
    }
  }
}
</script>
<style scoped>
.z-index-ten-thousand {
  z-index: 10000 !important;
}

.modal-body-full {
  /* 100% = dialog height, 120px = header + footer */
  min-height: calc(100vh - 60px);
  overflow-y: scroll;
}

.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: black;
  opacity: .5;
}

.header {
  width: 100%;
  padding: 10px;
  margin: 0;
  height: 70px
}

.ks-modal-new {
  position: fixed;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  top: 50%;
  opacity: 1 !important;
}
</style>

